import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import * as Animate from "react-reveal";
import BorderGradient from "../../../components/blocks/BorderGradient";
import MapImage from "../../../assets/images/png/about-map.webp";

const UbnHeader = () => {
  return (
    <>
      <header className="w-full bg-blue2">
        <HeaderNavigation bgdark={true} />
        <div className="pt-8 md:pt-12 lg:pt-16 pb-20 lg:pb-24 container mx-auto px-4">
          <div className="w-full md:10/12 lg:w-8/12 mx-auto text-center relative">
            <Animate.Fade bottom>
              <h2 className="w-11/12 md:w-10/12 lg:w-7/12 mx-auto text-3xl lg:text-4xl xl:text-5xl leading-relaxed xl:leading-tight font-semibold text-white font-mono py-6">
                Join the Utiva Business Network
              </h2>
              <p className="text-white text-base md:text-lg md:leading-8 py-2 lg:py-6 w-full lg:w-11/12 xl:w-9/12 mx-auto">
                Designed to equip organizations with the opportunity to enrich
                their talent economy and get insights into how to approach
                talent development.
              </p>

              <div className="flex justify-center">
                <a
                  href="https://forms.sendpulse.com/045a22e5ea/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-lg bg-secondary px-6 md:px-6 py-4 text-white text-sm-15 md:text-base mt-8 mb-6 focus:outline-none block"
                >
                  Get Started Now
                </a>
              </div>
            </Animate.Fade>
          </div>
        </div>

        <div className="w-full relative">
          <img src={MapImage} alt="Map" />
        </div>

        <div className="grid grid-cols-3 ">
          <BorderGradient />
        </div>
      </header>
    </>
  );
};

export default UbnHeader;
